var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#DFE0EB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2624_2201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2624_2201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H31V29H8V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2624_2201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6077 8.86642L18.8466 6.51647C19.2531 6.29114 19.7469 6.29114 20.1534 6.51647L30.6631 12.3428H8.33691L13.217 9.63737",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33691 12.3428H30.6631V13.3536C30.6631 13.9118 30.2106 14.3643 29.6523 14.3643H9.34766C8.78946 14.3643 8.33691 13.9118 8.33691 13.3536V12.3428Z",
    stroke: "url(#paint0_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78613 26.6416H30.2139C30.4619 26.6416 30.6631 26.8427 30.6631 27.0908V28.2139C30.6631 28.462 30.4619 28.6631 30.2139 28.6631H8.78613C8.53803 28.6631 8.33691 28.462 8.33691 28.2139V27.0908C8.33691 26.8427 8.53803 26.6416 8.78613 26.6416Z",
    stroke: "url(#paint1_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7129 9.59351C20.7129 10.2634 20.1699 10.8064 19.5 10.8064C18.8301 10.8064 18.2871 10.2634 18.2871 9.59351C18.2871 8.92363 18.8301 8.38062 19.5 8.38062C20.1699 8.38062 20.7129 8.92363 20.7129 9.59351Z",
    stroke: "url(#paint2_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3155 26.6416H23.9136L25.2612 24.7447H27.9678L29.3155 26.6416Z",
    stroke: "url(#paint3_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3155 14.3643H23.9136L25.2612 16.2613H27.9678L29.3155 14.3643Z",
    stroke: "url(#paint4_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2612 20.4554V16.2613H27.9678V24.7447H25.2612V22.0276",
    stroke: "url(#paint5_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0865 26.6416H9.68457L11.0322 24.7447H13.7388L15.0865 26.6416Z",
    stroke: "url(#paint6_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0865 14.3643H9.68457L11.0322 16.2613H13.7388L15.0865 14.3643Z",
    stroke: "url(#paint7_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7388 24.7447H11.0322V16.2613H13.7388V24.7447Z",
    stroke: "url(#paint8_linear_2624_2201)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2624_2201",
    x1: 47.4266,
    y1: 12.2806,
    x2: 47.4266,
    y2: 14.4252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2624_2201",
    x1: 47.4266,
    y1: 26.5793,
    x2: 47.4266,
    y2: 28.7239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2624_2201",
    x1: 22.5343,
    y1: 8.3059,
    x2: 22.5343,
    y2: 10.8794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2624_2201",
    x1: 33.3715,
    y1: 24.6863,
    x2: 33.3715,
    y2: 26.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2624_2201",
    x1: 33.3715,
    y1: 14.3059,
    x2: 33.3715,
    y2: 16.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2624_2201",
    x1: 30,
    y1: 16,
    x2: 30,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2624_2201",
    x1: 19.1425,
    y1: 24.6863,
    x2: 19.1425,
    y2: 26.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2624_2201",
    x1: 19.1425,
    y1: 14.3059,
    x2: 19.1425,
    y2: 16.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2624_2201",
    x1: 15.771,
    y1: 16,
    x2: 15.771,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2624_2201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankk);
export default __webpack_public_path__ + "static/media/bankk.5acb127a1e981d392f7a5d1dcc021305.svg";
export { ForwardRef as ReactComponent };